import { render, staticRenderFns } from "./CartCustomerAddressesManager.vue?vue&type=template&id=4b935613&"
import script from "./CartCustomerAddressesManager.vue?vue&type=script&lang=ts&"
export * from "./CartCustomerAddressesManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports